export default __webpack_public_path__ + "static/media/setting2.8f2b4748.svg";